import React, { useEffect, useState } from "react";
import "./css/faqs.css";
import { Link } from "react-router-dom";

const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5000";

const Faqs = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [headerSmall, setHeaderSmall] = useState("الأسئلة الشائعة");
  const [headerTitle, setHeaderTitle] = useState(
    "في نبض كير لدينا إجابات لكل استفساراتك"
  );
  const [items, setItems] = useState([
    {
      question: "كم تستغرق عملية تسجيل المنتجات في هيئة الغذاء والدواء؟",
      answer:
        "تختلف المدة حسب نوع المنتج (غذاء، دواء، تجميل). عادة ما تستغرق منتجات التجميل من 5 إلى 10 أيام عمل، بينما قد تستغرق المنتجات الغذائية وقتًا أقل إذا كانت المستندات مكتملة.",
    },
    {
      question: "ما هي المتطلبات الأساسية لإصدار رخصة صناعية؟",
      answer:
        "تتطلب الرخصة الصناعية وجود سجل تجاري ساري، عقد إيجار للمصنع أو الأرض، وموافقة مبدئية من وزارة الصناعة. نحن نساعدك في تجهيز المخططات الهندسية ودراسات الجدوى المطلوبة.",
    },
    {
      question: "هل تقدمون خدمات التخليص الجمركي في جميع منافذ المملكة؟",
      answer:
        "نعم، لدينا فريق متخصص وشراكات استراتيجية تغطي معظم المنافذ البرية والبحرية والجوية لضمان فسح شحناتك بسرعة وكفاءة.",
    },
    {
      question: "ما هو الفرق بين شهادة سابر (SABER) وشهادة الإرسالية؟",
      answer:
        "شهادة سابر هي شهادة مطابقة للمنتج تثبت أنه آمن ومطابق للمواصفات، وتصدر مرة واحدة سنوياً. أما شهادة الإرسالية فهي مطلوبة لكل شحنة مستوردة على حدة.",
    },
    {
      question: "كيف يمكنني البدء في طلب استشارة لمشروعي؟",
      answer:
        "يمكنك التواصل معنا مباشرة عبر الهاتف أو الواتساب، أو ملء نموذج 'طلب استشارة' في الموقع. سيقوم أحد خبرائنا بدراسة طلبك والرد عليك بخطة عمل واضحة.",
    },
  ]);

  useEffect(() => {
    const fetchFaqs = async () => {
      try {
        const res = await fetch(`${API_BASE_URL}/api/faqs`);
        if (!res.ok) return;
        const data = await res.json();
        if (data.faqs) {
          setHeaderSmall(data.faqs.headerSmall || headerSmall);
          setHeaderTitle(data.faqs.headerTitle || headerTitle);
          if (Array.isArray(data.faqs.items) && data.faqs.items.length > 0) {
            setItems(data.faqs.items);
          }
        }
      } catch {
        // fall back to defaults
      }
    };

    fetchFaqs();
  }, []);

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section className="faq-section">
      <div className="container">
        {/* Header */}
        <div className="faq-header">
          <h6>{headerSmall}</h6>
          <h2>{headerTitle}</h2>
        </div>

        <div className="row">
          {/* FAQ List (Right Side) */}
          <div className="col-lg-8 col-md-12">
            <div className="faq-list">
              {items.map((item, index) => (
                <div
                  key={`${item.question}-${index}`}
                  className={`accordion-item-custom ${
                    activeIndex === index ? "active" : ""
                  }`}
                >
                  <div
                    className="accordion-header-custom"
                    onClick={() => toggleAccordion(index)}
                  >
                    <h4>{item.question}</h4>
                    <div className="accordion-icon">
                      <i
                        className={`fa-solid ${
                          activeIndex === index ? "fa-minus" : "fa-plus"
                        }`}
                      ></i>
                    </div>
                  </div>

                  <div className="accordion-body-custom">
                    <p>{item.answer}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Support Card (Left Side) */}
          <div className="col-lg-4 col-md-12">
            <div className="support-card">
              <div className="icon-wrapper mb-4">
                <i
                  className="fa-solid fa-headset fa-3x"
                  style={{ color: "#ee7c0c" }}
                ></i>
              </div>
              <h3>لم تجد إجابة لسؤالك؟</h3>
              <p>
                فريق نبض كير متاح للإجابة على جميع استفساراتك الفنية والقانونية. لا
                تتردد في التواصل معنا.
              </p>
              <Link to="/contact" className="support-btn">
                تواصل مع نبض كير الآن
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Faqs;